import { BsCheck } from 'react-icons/bs';

const DEFAULT_STEPS = [
  { id: 'tour', label: 'Tour' },
  { id: 'options', label: 'Options' },
  { id: 'details', label: 'Your details' },
  { id: 'payment', label: 'Payment' },
];

/**
 * @param {object} props
 * @param {number} props.currentStep
 * @param {{ id: string, label: string }[]} [props.steps]
 * @param {(step: number) => void} [props.onStepClick] - called for completed steps, plus clickableSteps
 * @param {number[]} [props.clickableSteps]
 * @param {string} [props.className]
 */
const BookingProgress = ({
  currentStep = 1,
  steps = DEFAULT_STEPS,
  onStepClick,
  clickableSteps = [],
  className = '',
}) => {
  const items = Array.isArray(steps) && steps.length > 0 ? steps : DEFAULT_STEPS;
  const step = Math.min(items.length, Math.max(1, Number(currentStep) || 1));
  const extraClickable = new Set((clickableSteps || []).map((n) => Number(n)));

  return (
    <nav
      className={`booking-progress ${className}`.trim()}
      aria-label="Booking progress"
    >
      <ol className="booking-progress__list">
        {items.map((item, index) => {
          const n = index + 1;
          const isComplete = n < step;
          const isCurrent = n === step;
          const isClickable = typeof onStepClick === 'function' && (isComplete || extraClickable.has(n));

          return (
            <li
              key={item.id}
              className={[
                'booking-progress__item',
                isComplete ? 'is-complete' : '',
                isCurrent ? 'is-current' : '',
                !isComplete && !isCurrent ? 'is-upcoming' : '',
              ].filter(Boolean).join(' ')}
            >
              {isClickable ? (
                <button
                  type="button"
                  className="booking-progress__btn"
                  aria-current={isCurrent ? 'step' : undefined}
                  onClick={() => onStepClick(n)}
                >
                  <span className="booking-progress__marker" aria-hidden>
                    {isComplete ? <BsCheck size={14} /> : n}
                  </span>
                  <span className="booking-progress__label">{item.label}</span>
                </button>
              ) : (
                <span
                  className="booking-progress__static"
                  aria-current={isCurrent ? 'step' : undefined}
                >
                  <span className="booking-progress__marker" aria-hidden>
                    {isComplete ? <BsCheck size={14} /> : n}
                  </span>
                  <span className="booking-progress__label">{item.label}</span>
                </span>
              )}
              {index < items.length - 1 && (
                <span className="booking-progress__connector" aria-hidden />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BookingProgress;
